import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=b13df394&scoped=true&"
import script from "./FormError.vue?vue&type=script&lang=ts&"
export * from "./FormError.vue?vue&type=script&lang=ts&"
import style0 from "./FormError.vue?vue&type=style&index=0&id=b13df394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13df394",
  null
  
)

export default component.exports